import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XpoLtlBaseCacheService } from '@xpo-ltl/ngx-ltl';
import { ClaimsApiService, ListExaminerActiveClosedClaimsResp, ListExaminerActiveClosedClaimsQuery } from '@xpo-ltl-2.0/sdk-claims';
import * as _ from 'lodash';
import { AssignedActiveClosedCacheParams } from '../../interfaces/assigned-active-closed-cache-params.interface';
import { ApiRequest } from '@xpo-ltl/data-api';
import { ListInfo } from '@xpo-ltl/sdk-common';

@Injectable()
export class ListExaminerActiveClosedCacheService extends XpoLtlBaseCacheService<AssignedActiveClosedCacheParams, ListExaminerActiveClosedClaimsResp> {
  constructor(private claimsApiService: ClaimsApiService) {
    super();
  }

  protected getKeyFromParams(params: AssignedActiveClosedCacheParams): string {
    return `${params.index}`;
  }

  protected requestData(params: AssignedActiveClosedCacheParams): Observable<ListExaminerActiveClosedClaimsResp> {
    const request = new ListExaminerActiveClosedClaimsQuery();
    _.assign(request, _.pick(params, _.keys(request)));
    request.examinerEmployeeId = params.employeeId;
    request.listInfo = new ListInfo();
    request.listInfo.startAt = params.startAt;
    request.listInfo.numberOfRows = params.numberOfRows;
    request.listInfo.sortFields = [{sortByFieldName: params.sortByFieldName.toString(), sortOrder: params.sortOrder.toString()}];

    return this.claimsApiService.listExaminerActiveClosedClaims(request, { ...ApiRequest.defaultDataOptions, toastOnError: false });
  }
}
